module.exports = __webpack_public_path__ + "static/media/thumbsup.72418c50.svg";